export const config = {
    baseAPIURI: `/v0-1`,
    deviceHost: `https://todar.hazenai.com/backend`,
    serverHost: `https://todar.hazenai.com/backend`,
    mediaServer: `https://todar.hazenai.com/media/static/`
}



// WEBPACK FOOTER //
// ./src/config/config.prod.ts